// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__UeaNh","checkbox":"Checkbox_checkbox__sv+0O","checkboxInverted":"Checkbox_checkboxInverted__0huYk","label":"Checkbox_label__PSqq+"};